import JoinTeamPage from "@/pages/join-team-page"
import createComponent from "@/utils/create-component"

export default () => {
  const el = document.getElementById("vue-team-signup")

  if (!el) {
    // prevent trying to mount the component when in another page
    return
  }

  const { lastPageBeforeLogin } = el.dataset || {}

  createComponent({
    el: el,
    component: JoinTeamPage,
    props: {
      lastPageBeforeLogin
    }
  })
}
